import React from 'react';
import { Button } from '../ButtonElements';
import { BtnWrap, Column1, Column2, Heading, InfoContainer, InfoRow, InfoWrapper, Subtitle, TextWrapper, TopLine } from '../AboutSection/AboutElements';

const AboutSection = ({lightBg,id,imgStart,topLine,topLine2,lightText,headline,headline2,darkText,description,description2,buttonLabel,buttonLabel1,primary, dark,dark2}) => {
    return (
        <>
         <InfoContainer lightBg={lightBg} id={id}>
            <InfoWrapper>
                <InfoRow imgStart={imgStart}>
                    <Column1>
                        <TextWrapper>
                            <TopLine>{topLine}</TopLine>
                            <Heading lightText={lightText}>{headline}</Heading>
                            <Subtitle darkText={darkText}>{description}</Subtitle>
                            <BtnWrap>
                                <Button to='services'
                                    smooth= {true}
                                    duration= {500}
                                    spy={true}
                                    exact='true'
                                    offset={-80}
                                    primary={primary ? 1 :0}
                                    dark={dark ? 1:0}
                                    dark2={dark2 ? 1:0}
                                >{buttonLabel1}</Button>
                            </BtnWrap>
                        </TextWrapper>
                    </Column1>
                    <Column2>
                        {/* <ImgWrap>
                            <Img src={img} alt={alt} />
                        </ImgWrap> */}
                        <TextWrapper>
                            <TopLine>{topLine2}</TopLine>
                            <Heading lightText={lightText}>{headline2}</Heading>
                            <Subtitle darkText={darkText}>{description2}</Subtitle>
                            <BtnWrap>
                                <Button to='contact'
                                    smooth= {true}
                                    duration= {500}
                                    spy={true}
                                    exact='true'
                                    offset={-80}
                                    primary={primary ? 1 :0}
                                    dark={dark ? 1:0}
                                    dark2={dark2 ? 1:0}
                                >{buttonLabel}</Button>
                            </BtnWrap>
                        </TextWrapper>
                    </Column2>
                </InfoRow>
            </InfoWrapper>
         </InfoContainer>   
        </>
    )
}

export default AboutSection
